// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r6-6";
export var imgContainer = "_r6-3";
export var menuIcon = "_r6-5";
export var pillWrapper = "_r6-2";
export var pillsContainer = "_r6-1";
export var subscriptionCard = "_r6-0";
export var subscriptionLogo = "_r6-4";